export default {"src":"/_next/static/media/customer-service-agent.8d032ff9.svg","height":24,"width":24};